import { render, staticRenderFns } from "./CoursewareManagement.vue?vue&type=template&id=bf851c0e&scoped=true&"
import script from "./CoursewareManagement.vue?vue&type=script&lang=js&"
export * from "./CoursewareManagement.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareManagement.vue?vue&type=style&index=0&id=bf851c0e&lang=less&scoped=true&"
import style1 from "./CoursewareManagement.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf851c0e",
  null
  
)

export default component.exports